import { MINUTES_PER_DAY, normalizeRuleWindow } from "./ruleDerivation";
import type { RuleWindow } from "./ruleTypes";

export const MIN_SMART_BLOCK_DURATION_MINUTES = 60;

export type SmartBlockWindowValidationError = "endBeforeStart" | "tooShort" | "crossesMidnight";

export type SmartBlockWindowValidationResult =
  | { ok: true; window: RuleWindow }
  | { ok: false; error: SmartBlockWindowValidationError };

export function validateSmartBlockWindow(window: RuleWindow): SmartBlockWindowValidationResult {
  const startMinute = Math.round(window.startMinute);
  const endMinute = Math.round(window.startMinute + window.durationMinutes);

  if (endMinute <= startMinute) {
    return { ok: false, error: "endBeforeStart" };
  }
  if (endMinute > MINUTES_PER_DAY) {
    return { ok: false, error: "crossesMidnight" };
  }
  if (endMinute - startMinute < MIN_SMART_BLOCK_DURATION_MINUTES) {
    return { ok: false, error: "tooShort" };
  }

  return {
    ok: true,
    window: normalizeRuleWindow({ startMinute, durationMinutes: endMinute - startMinute }),
  };
}

export function assertSmartBlockWindow(window: RuleWindow): RuleWindow {
  const result = validateSmartBlockWindow(window);
  if (!result.ok) {
    if (result.error === "tooShort") {
      throw new Error(`Smart Block must be at least ${MIN_SMART_BLOCK_DURATION_MINUTES} minutes long.`);
    }
    if (result.error === "endBeforeStart") {
      throw new Error("End time must be after start time.");
    }
    throw new Error("Smart Block window must stay within the same day.");
  }
  return result.window;
}

export function ruleWindowsEqual(a: RuleWindow, b: RuleWindow): boolean {
  return a.startMinute === b.startMinute && a.durationMinutes === b.durationMinutes;
}
